module.exports = __webpack_public_path__ + "da8398d3020941b5bcfd3c54c9eb1d71.png";